<!--
 * @Author: Merlin
 * @Date: 2025-06-19 14:08:34
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-19 17:09:48
 * @Description: 
不提供换厅功能： 换厅的就不要了。让玩家手动去 换 

-->

<template>
    <article class="game-wrap relative">
        <div class="game-background max-width">
        </div>
        <div class="game-inner max-width py-3 px-3 sm:py-2 relative">
            <ClientOnly>
                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-0">
                    <GameSettingsButtonFast v-model="gameStore.goldenFlower.fast" />
                    <GameSettingsButtonRule v-model="oVisible.isOpenRule" name="goldenFlowerGame" />
                    <GameSettingsButtonVocie v-model="settingStore.inhouseGames.sound.on"
                        v-model:voice-model-value="settingStore.inhouseGames.sound.music" :saveAfterChange="true">
                    </GameSettingsButtonVocie>
                </GameSettingsDiceTabsWrapper>
            </ClientOnly>
            <!--
                ↑ 通用控制条 
                ↓ 游戏区 
            -->
            <section class="history-bar flex items-center">
                <div class="first-line">
                    <button class="history-btn" @click="showHistoryList">
                        <IconSvgUse use="icon-statistic-3" size="18px" />
                        {{ $t('History') }}
                    </button>
                </div>
                <ScrollingNotice :list="noticeList"/>
            </section>
            <section :ref="el => oStageDom = el as any" class="game-stage" :class="{
            }" :style="{
                '--name-tag-width': sNameTagWidth,
            }">
                <div class="ratio-box">
                    <img v-if="oVisible.showCallLast" :src="lastImg" alt="" class="absolute bottom-1/2 translate-y-1/2 z-10">
                    <div class="room-name">{{ $t(`goldenFlower.${roomName}`) }}</div>
                    <img src="../img/logo.webp" alt="" class="logo">
                    <div class="players">
                        <div class="dealer">
                            <img src="../img/dealer.webp" class="w-[60px]" />
                            <nameTag :userName="$t('goldenFlower.dealer')" :dealer="true" />
                            <div class="dealer-wager-box">
                                <wagerAmount class="dealer-wager" :wagerValue="roomTable.poolAmount" :dealer="true"
                                    ref="dealerWagerRef" />
                                    <img  class="dealer-box-img" src="../img/box.webp" alt="">
                            </div>
                            <span class="info-bar">
                                {{ $t('goldenFlower.turns') + ': ' }}
                                <em>
                                    {{ `${roomTable.currentRound}/${10}` }}
                                </em>
                                {{ $t('goldenFlower.ante') + ': ' }}
                                <em>
                                    {{ roomTable.minBet }}
                                </em>
                                {{ $t('goldenFlower.limit') + ': ' }}
                                <em>
                                    {{ roomTable.maxBet }}
                                </em>
                            </span>
                        </div>
                        <!-- 
                            ↑ 发牌荷官 
                            ↓ 线上的玩家 
                        -->
                        <div v-for="(oRoommate, idx) of playerList" :key="idx" class="relative" :class="{
                            [idx === 4 ? 'user-self' : 'adversary']: true,
                        }">
                            <onePlayer ref="playerRef" :atRight="[2, 4].includes(idx + 1)" :userInfo="oRoommate"
                                :gamerID="String(idx + 1)" :seatIndex="idx + 1" :gameWinner="pkWinner"
                                :gamersInPk="gamersInPk" :round-time="seconds.round"
                                :is-banker="roomTable.dealerID === oRoommate?.id"
                                :show-progress="roomTable.currentTurnPlayerID === oRoommate?.id && (!!timers.round || !!timers.backend)"
                                :msgInfo="msgList[idx]" :show-result="oVisible.showResult"
                                :isSelect="oVisible.showSelect && !oRoommate?.isQuit && oRoommate?.inGame"
                                :isCompaire="oVisible.showBlackMask" @view-card="() => viewCard(false, false)" @select-user="startPk" />
                        </div>
                        <!-- ↓ 显示游戏结果（连线和VS球分步消失） -->
                        <div class="floating-box" v-if="gamersInPk">
                            <Transition name="pk-line">
                                <span v-if="oVisible.showPkLine" :data-two-numbers="gamersInPk" :class="{ [`line-${gamersInPk}`]: true }"></span>
                            </Transition>
                            <Transition name="pk-line">
                                <span v-if="oVisible.showPkLine && gamersInPk.endsWith('5')" class="line-for-user-5"></span>
                            </Transition>
                            <Transition name="pk-vs">
                                <span v-if="oVisible.showPkVs" class="vs-ball-box" :class="{
                                    [`ball-${gamersInPk}`]: true,
                                }">
                                    <img src="../img/VS.png" />
                                </span>
                            </Transition>
                        </div>
                    </div>
                    <!-- 提示文字 -->
                    <div v-if="oVisible.showSelect" class="select-text whitespace-nowrap !z-10">
                        {{ $t('goldenFlower.selectUser') }}
                    </div>
                    <div v-if="showWaitNext" class="info-wrap text-[#F6DF33] text-[13px]">
                        <span>{{ $t('goldenFlower.waitnext') }}</span>
                        <LoadingDots />
                    </div>
                    <div v-if="(timers.ready || gamerNum === 1 || oVisible.showReady) && !isOver"
                        class="info-wrap text-[#F6DF33] text-[13px]">
                        <span v-if="timers.ready || oVisible.showReady">{{ $t('goldenFlower.ready') }}</span>
                        <span v-else>{{ $t('goldenFlower.wait') }}</span>
                        <LoadingDots />
                        <span v-if="(timers.ready || oVisible.showReady) && seconds.ready >= 0">({{ seconds.ready }})</span>
                    </div>
                    <!-- 结算阶段飞筹码动画层 -->
                    <div class="chips-layer" v-if="flyingChips.length">
                        <div v-for="chip in flyingChips" :key="chip.id" class="flying-chip" :style="chip.style">
                            <img src="../img/chip.webp" style="width: 14px;">
                        </div>
                    </div>
                    <!-- 全押动画 -->
                    <Anamation v-if="allInAnimationVisible" :show-hand="showHand"/>
                </div>
            </section>
            <!--
                ↑ 游戏舞台，游戏区 
                | ================================================
                | ================================================
                | ================================================ 
                ↓ 下注面板，表单
            -->
            <section :class="{ 'bottom-box': true, 'z-20': oVisible.showSelect }">
                <div v-if="isGaming" class="btn-group-playing">
                    <button class="colorful-btn color-red" :class="{ 'disabled-btn': isAuto }" :disabled="isAuto"
                        @click="onFold">
                        {{ $t('goldenFlower.Fold') }}
                    </button>
                    <!-- 跟注 -->
                    <button v-if="!otherTurn && !isAuto" class="colorful-btn color-orange"
                        :class="{ 'disabled-btn': otherTurn || isAllIn }" :disabled="otherTurn || isAllIn"
                        @click="onCall">
                        <template v-if="isLastBet">{{ $t('goldenFlower.CallLast') }}</template>
                        <template v-else>
                            {{ $t('goldenFlower.CallOnce', { val: isWatch ? mine.raiseNum * 2 : mine.raiseNum }) }}
                        </template>
                    </button>
                    <!-- 跟到底 -->
                    <button v-if="isAuto || otherTurn" class="colorful-btn color-orange"
                        :class="{ 'disabled-btn': isAllIn }" :disabled="isAllIn">
                        <label class="flex items-center justify-center">
                            <input v-model='isAuto' type="checkbox" class='mr-1' :disabled="isAllIn">
                            {{ $t('goldenFlower.CallAllTheway') }}
                        </label>
                    </button>
                    <!-- 加注按钮相关 -->
                    <div class="relative">
                        <div v-show="oVisible.showRaiseOption" class="raise-options">
                            <button class="colorful-btn color-green w-full"
                                :class="{ 'disabled-btn': !canAllIn || roomTable.currentRound === 10 }"
                                :disabled="!canAllIn || roomTable.currentRound === 10" @click="onAllIn">{{
                                    $t('goldenFlower.AllIn')
                                }}</button>
                            <button v-for="it in raiseOption" :key="it.val" class="colorful-btn color-green w-full"
                                :class="{ 'disabled-btn': it.disabled }" :disabled="it.disabled"
                                @click="onRaise(it.val)">{{
                                    $t('goldenFlower.RaiseVal', { val: it.val }) }}</button>
                            <button class="colorful-btn color-green relative z-10 w-full" @click="toggleRaiseOption()">
                                {{ $t('goldenFlower.Raise') }}
                            </button>
                        </div>
                        <button v-if="!oVisible.showRaiseOption" class="colorful-btn color-green relative w-full"
                            :class="{ 'disabled-btn': isDisableRaise }" :disabled="isDisableRaise"
                            @click="toggleRaiseOption()">
                            {{ $t('goldenFlower.Raise') }}
                        </button>
                    </div>
                    <button class="colorful-btn color-blue" :class="{ 'disabled-btn': isDisableMatch }"
                        :disabled="isDisableMatch" @click="onCompare">
                        {{ $t('goldenFlower.Match') }}
                    </button>
                </div>
                <div v-else class="btn-group-not-gaming">
                    <button class="colorful-btn color-red" :class="timers.change ? 'disabled-btn' : ''"
                        :disabled="!!timers.change || isReady" :dismark="!!timers.change || isReady" v-click-and-rest="3000" @click="changeTable">
                        {{ $t('goldenFlower.Change') }}
                        <span v-if="timers.change">
                            ({{ seconds.change }})
                        </span>
                    </button>
                    <button v-if="showCardVisible" class="colorful-btn color-blue"
                        :class="{ 'disabled-btn': showCardDisabled }"
                        :disabled="showCardDisabled" @click="onShowCard">
                        {{ $t('goldenFlower.Reveal') }}
                    </button>
                </div>
            </section>
        </div>
        <!-- ↓ 修改 dom 位置恐引发出错，改时要注意 -->
        <Transition name="fade">
            <div class="black-mask" :class="{z3: oVisible.showSelect }" v-show="oVisible.showBlackMask"></div>
        </Transition>
    </article>
    <!-- 匹配倒计时弹窗 -->
    <TimeDialog v-if="showTimeDailog" :name="$t(`goldenFlower.${roomName}`)" :time="seconds.roomWaiting"
        :show-time="!!timers.roomWaiting" @quite="goback" @rematch="changeTable" />
    <!-- 
        ↑ 游戏区 
        =============================================
        ↓ 弹出窗口 
    -->
    <!-- ↓ 历史“列表” 窗口 -->
    <HistoryList v-model="oVisible.historyList"></HistoryList>
    <!-- ↓ 历史“详情” 窗口，在此监听 route 参数变化并打开 -->
    <CasinoHistoryModalGameDetali :gameDropValue="'goldenFlower'" />
    <!-- ↓ 余额不足提示弹窗 -->
    <NoticeDialog v-model="showLowBalanceDialog" :displayTitle="$t('Note')" :main-text="$t('goldenFlower.lowBalance')"
        :displaySubText="$t('niuniu.rechargePrompt')" :displayButtonText="$t('commonInfo.confirm')"
        @confirm="handleLowBalanceConfirm" />
    <!-- 重新比牌弹窗提示 -->
    <CompareDailog v-if="oVisible.showCompareDialog" @re-compare="reCompare" />
    <!-- 终局比牌弹窗 -->
    <LastDialog v-if="oVisible.showFinal" :isfinal-player="isfinalPlayer" :player-list="finalPlayer.list" :winner="finalPlayer.winIds" />
</template>

<script lang="ts" setup>
import nameTag from '../_components/nameTag.vue';
import wagerAmount from '../_components/wagerAmount.vue';
import onePlayer from '../_components/player.vue';
import HistoryList from '../_components/historyList.vue';
import ScrollingNotice from '../_components/ScrollingNotice.vue';
import NoticeDialog from '@/components/NoticeDialog.vue';
import TimeDialog from '../_components/TimeDialog.vue';
import CompareDailog from '../_components/CompareDailog.vue';
import Anamation from '../_components/Anamation.vue';
import LastDialog from '../_components/LastDialog.vue';
// --- ↑ 组件  ---------------- 
import GameGBM from '@/assets/mp3/game_general_bgm.mp3';
import musicLose from '@/assets/mp3/redPacket/lose.mp3';
import musicWin from '@/assets/mp3/redPacket/win.mp3';
import musicSending from '@/assets/mp3/redPacket/sending.mp3';
import musicCollecting from '@/assets/mp3/redPacket/collecting.mp3';
import { playMusic, unlockAudio, clearAllZhajinhuaSounds } from '../ts/music';
// ---- ↑ 音乐区 --------------  
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
import { useGoldenFlower } from '@/socket/game/goldenFlower';
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import useGlobalStore from '@/stores/global';
import { fnGoToEntrance, goHome, rotateAndMapPlayers, findLastInGamePlayer, getTwoRandomIndexesNonEmpty } from '../ts/goldenFlowerCommon';
import { defaultSeconds, msgTag } from '../ts/constants';
import type { Player, ActionMsg } from '../ts/types';
import { getHallsList } from '~/pages/casino/zhajinhuaGame/ts/goldenFlowerCommon';
import { playChipsSettlementAnimation, type FlyingChip } from '../ts/animation';
import { useAuthSocket } from '~/socket/auth';
import { socket } from '@/utils/webSocket';
import lastcn from '../img/call-last-cn.gif'
import lasten from '../img/call-last-cn.gif'

const settingStore = useSettingsStore();
const oGlobalStore = useGlobalStore();
const userStore = useUserStore();
const joinStateStore = useJoinStateStore();
const gameStore = storeToRefs(settingStore).game;
const currency = storeToRefs(settingStore).pickedCurrency;
const { ON_STATECHANGE } = useAuthSocket();
// -------- ↑ store 等 -------------------------------------- 
const oRoute = useRoute();
const { t: $tFn, locale } = useNuxtApp().$i18n;
const router = useRouter();
const showNoticeDialog = useNoticeDialog();
// 标记是否是语言切换
const isLanguageSwitching = ref(false);
const {
    EMIT_CHECK_PLAYER_TABLEINFO,
    EMIT_ZHAJINHUA_JOINTABLE,
    EMIT_ZHAJINHUA_JOIN,
    EMIT_ZHAJINHUA_TABLEINFO,
    EMIT_ZHAJINHUA_SEE,
    EMIT_ZHAJINHUA_FOLD,
    EMIT_ZHAJINHUA_CALL,
    EMIT_ZHAJINHUA_ALLIN,
    EMIT_ZHAJINHUA_RAISE,
    EMIT_ZHAJINHUA_COMPAIRE,
    EMIT_ZHAJINHUA_LEAVE,
    EMIT_ZHAJINHUA_EXIT,
    EMIT_ZHAJINHUA_SHOWCARD,
    EMIT_ZHAJINHUA_CHANGETABLE,
    EMIT_ZHAJINHUA_PLAYCONFIRM,
    ON_TABLE,
    ON_PLAYER,
    ON_NOTICE,
    ON_SERVICERESTART,
} = useGoldenFlower();
let dialog;
let isNoticeDialogShowing = false; // 标记弹窗是否正在显示
const noticeList = reactive([]);
const finalPlayer = reactive({
    list: [],
    winIds: []
})
// 音乐列表
const oMusicLib = {
    bg: {
        src: GameGBM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    win: { src: musicWin, },
    lose: { src: musicLose, },
    sending: { src: musicSending, },
    collecting: { src: musicCollecting, }, // 这顶似乎作用不大，
};

const oMusic = (
    import.meta.client
        ? new MusicControler(oMusicLib as any)
        : null
);

// ----- ↑ 导入公共资源 ----------------------
// ----- ↓ 本地数据 ----------------------
const ZHAJINHUA_INDOOR = '/casino/zhajinhuaGame/indoor';
const sNameTagWidth = '70px';
const oStageDom = ref<HTMLElement | null>(null);
const mine = reactive({ id: undefined, seatIndex: undefined, tableId: undefined, raiseNum: 0 });

// 是否跟到底
const isAuto = toRef(settingStore.game.goldenFlower, 'isChecked');
// 是否开始结算
const isOver = ref(false);
// 游戏是否即将开始(准备倒计时最后一秒的时候禁止退出操作)
const isReady = ref(false);
// 是否全压
const isAllIn = ref(false);
// 是否换桌失败
const ischangeFail = ref(false);
// 本局是否已亮牌（每局只能亮一次）
const hasShownCard = ref(false);
// 是否被踢出房间
const isAutoLeave = ref(false);
// 牌桌status 是否是 Waiting
// 元素可见性管理中心 
const oVisible = reactive({
    isOpenRule: false,
    historyList: false, // 历史窗口 
    showBlackMask: false,
    showSelect: false,
    showRaiseOption: false, // 是否显示跟注选项
    showResult: false, // pk结果图片
    showReady: false,
    showCallLast: false, // 最后一博图片
    showPkLine: false, // pk连线
    showPkVs: false, // pk VS球
    showCompareDialog: false, // 比牌中对手弃牌，重新选择比牌弹窗
    showFinal: false, // 终局比牌弹窗
});
// 余额不足弹窗
const showLowBalanceDialog = ref(false);

const playerRef = ref<any[]>([]);
const dealerWagerRef = ref<any | null>(null);

// 飞筹码动画数据
const flyingChips = ref<FlyingChip[]>([]);
const flyingChipIdRef = { current: 0 };

// ↓ 5个玩家 
const aGamerList = reactive<(undefined | Player)[]>([undefined, undefined, undefined, undefined, undefined]);

// 玩家操作消息（展示在玩家头像上面）
const msgList = reactive<ActionMsg[]>([undefined, undefined, undefined, undefined, undefined]);

// 当前桌信息
const roomTable = reactive({
    currentRound: 0,
    currentTurnPlayerID: 0,
    dealerID: 0,
    hallName: undefined,
    id: undefined,
    maxBet: '',
    minBet: '',
    poolAmount: '0',
    status: ''
});

// ↓ 保存游戏结果 
const oGameResult = reactive({
    pk: [], // pk中的玩家座位号
    hasWon: null, // null 输赢结果不明，布尔表示输赢结果 
    winner: '',
    banner: 4, // 庄家位置
});
// ----- ↓ 定时器相关 ----------------------
type TimerKey = 'ready' | 'change' | 'round' | 'over' | 'autoCall' | 'backend' | 'pkInit' | 'settled' | 'pkView' | 'pKResult' | 'pkLineHide' | 'pkVsHide' | 'chips' | 'roomWaiting' | 'gameStartGuard' | 'final'
const timers = reactive({
    ready: null, // 游戏开始定时器
    change: null, // 换桌定时器
    round: null, // 回合定时器
    autoCall: null, // 跟到底（自动跟）
    over: null,
    backend: null, // 后端返回倒计时的定时器
    settled: null, // 结算信息展示定时器
    pkView: null, // 比牌延时展示手牌定时器
    pkInit: null, // pk后初始化pk定时器
    pKResult: null, // pk结果延时展示定时器
    pkLineHide: null, // pk连线消失定时器
    pkVsHide: null, // pk VS球消失定时器
    chips: null, // 结算飞筹码动画定时器
    roomWaiting: null, // 房间弹窗倒计时
    gameStartGuard: null, // 开始游戏后，等待 gameStart 推送兜底定时器
    final: null // 终局开牌
});
const seconds = reactive({
    ready: defaultSeconds.ready, // 游戏开始倒计时
    change: defaultSeconds.change, // 换桌倒计时
    round: defaultSeconds.round, // 玩家回合倒计时
    over: defaultSeconds.over, // 游戏结束结算时间
    roomWaiting: defaultSeconds.roomWaiting // 房间弹窗匹配倒计时
});

const clearTimer = (key: TimerKey) => {
    const timer = timers[key];
    if (key === 'ready') {
        oVisible.showReady = false;
        // 与开局倒计时定时器一致：清除 ready 时必须复位，否则换桌按钮仍被 isReady 卡住（弃牌/结算/清定时器等路径只 clear 未走 initBool）
        isReady.value = false;
    }
    if (timer) {
        clearInterval(timer);
        clearTimeout(timer);
        timers[key] = null;
        // 只有 seconds 中存在的 key 才重置
        if (key in seconds) {
            seconds[key] = defaultSeconds[key];
        }
    }
}

const clearAllTimer = (excludeKey?: TimerKey | TimerKey[]) => {
    const excludeKeys = Array.isArray(excludeKey) ? excludeKey : (excludeKey ? [excludeKey] : []);
    (Object.keys(timers) as TimerKey[]).forEach((key) => {
        if (!excludeKeys.includes(key)) clearTimer(key);
    });
}

const startGameStartGuard = () => {
    clearTimer('gameStartGuard');
    timers.gameStartGuard = setTimeout(() => {
        clearTimer('gameStartGuard');
        showNegativeNotify({
            position: 'top',
            i18n: 'goldenFlower.netError',
            type: 'warning',
        });
    }, 3000);
}
// ----- ↑ 定时器相关 ----------------------

/**
 * 旋转玩家数组，确保自己（isSelf=true）永远在数组最后一个位置
 * 其他玩家的顺序保持不变
 */
const playerList = computed(() => {
    const list = aGamerList.map(it => {
        if (it?.id) return { ...it, isSelf: it.id === userStore.id };
        return it;
    });
    return rotateAndMapPlayers(list);
});

// 玩家自己
const playerSelf = computed(() => aGamerList.find(it => it?.id === userStore.id));

// 牌局中最后操作的玩家id
const lastPlayerId = computed(() => findLastInGamePlayer(aGamerList, roomTable.dealerID)?.id);

// 自己是否已看牌
const isWatch = computed(() => playerSelf.value?.isWatchCards);

// 是否最后一搏（玩家金币不足以进行跟注）
const isLastBet = computed(() => {
    const total = playerSelf.value?.chips;
    return Number(total) < mine.raiseNum * (isWatch.value ? 2 : 1);
});

// 跟注选项
const raiseOption = computed(() => {
    const base = [Number(roomTable.maxBet), Number(roomTable.maxBet) / 2, Number(roomTable.maxBet) / 5]
    let list = isWatch.value ? base : base.map(it => it / 2);
    return list.map(val => ({ val, disabled: mine.raiseNum * (isWatch.value ? 2 : 1) >= val || isAllIn.value }))
})

// 牌桌玩家数
const gamerNum = computed(() => aGamerList.filter(it => it?.id)?.length);

// 游戏中玩家数量
const gamerInGame = computed(() => aGamerList.filter(it => it?.id && it?.inGame && !it?.isQuit && !it?.isLose)?.length);

// 是否是其他人回合
const otherTurn = computed(() => roomTable.currentTurnPlayerID !== userStore.id);

const canAllIn = computed(() => gamerInGame.value === 2 && roomTable.currentRound >= 4);

// 玩家 PK 连线 
const gamersInPk = computed(() => {
    // 复制数组避免直接修改原数组
    const sTwoPlays = [...(oGameResult.pk || [])];
    sTwoPlays.sort((aa, bb) => {
        // ↓ 一定要设为升序 
        return aa - bb;
    });
    const sResult = sTwoPlays.join('');
    console.log(`sTwoPlays`, deepCopy(sTwoPlays), sResult);
    return sResult;
});

const pkWinner = computed(() => oGameResult.winner);

const hallName = computed(() => oRoute?.query?.name);

const isGaming = computed(() => {
    return playerList.value.find(cur => {
        return cur?.inGame && !cur?.isLose && !cur?.isQuit && cur?.isSelf
    });
})
const isfinalPlayer = computed(() => finalPlayer.list.find(it => it.id === userStore.id))
const showCardVisible = computed(() => playerList.value.find((it) => it?.isSelf)?.cards?.filter?.(it => it?.rank)?.length > 0);
const showCardDisabled = computed(() => hasShownCard.value);
const showWaitNext = computed(() => !playerSelf.value?.inGame && roomTable.status === 'Playing' && gamerNum.value !== 1);
const isDisableRaise = computed(() => ((otherTurn.value || isAuto.value) || (raiseOption.value.every(it => it.disabled) && !canAllIn.value)) || roomTable.currentRound === 10 && lastPlayerId.value === playerSelf.value?.id);
const isDisableMatch = computed(() => otherTurn.value || isAuto.value || roomTable.currentRound < 2 || isAllIn.value);
const roomName = computed(()=>{
    const idx = +(oRoute?.params?.id) || 1;
    return { 1: 'novice', 2: 'leisure', 3: 'flagship', 4: 'royal', 5: 'supreme' }[idx];
})
const lastImg = computed(() => locale.value === 'cn' ? lastcn : lasten);
const showTimeDailog = computed(() => gamerNum.value === 1 && !isOver.value);
const allInAnimationVisible = ref(false);
const showHand = ref(false);
let allInAnimationTimer: ReturnType<typeof setTimeout> | null = null;
// ===================================================================================
//          ↑ 陈列数据
//          ↓ 一些方法 
// ===================================================================================

const goback = () => {
    if (dialog) dialog.hide();
    fnGoToEntrance();
}

const backHome = () => {
    if (dialog) dialog.hide();
    goHome();
}

const playAllInAnimation = (isSelf = true) => {
    showHand.value = isSelf;
    allInAnimationVisible.value = true;
    if (allInAnimationTimer) {
        clearTimeout(allInAnimationTimer);
    }
    allInAnimationTimer = setTimeout(() => {
        allInAnimationVisible.value = false;
        allInAnimationTimer = null;
    }, 1200);
}

// 根据玩家 id 获取对应的 player 组件实例
const getPlayerComponentById = (uid: number | string) => {
    if (!uid) return null;
    const idx = playerList.value.findIndex(it => it?.id === uid);
    if (idx === -1) return null;
    return playerRef.value[idx] || null;
};

// 结算时飞筹码动画的包装函数（用于简化调用）
const playChipsSettlementAnimationWrapper = (data: any[] = []) => {
    const stageEl = oStageDom.value as unknown as HTMLElement | null;
    playChipsSettlementAnimation(
        data,
        getPlayerComponentById,
        dealerWagerRef.value,
        stageEl,
        flyingChips,
        flyingChipIdRef
    );
};
// 切换加注选项显示住状态
const toggleRaiseOption = (val?: boolean) => {
    oVisible.showRaiseOption = val ?? !oVisible.showRaiseOption;
}

// 初始化玩家
const initPlayer = () => {
    aGamerList.forEach((it, idx) => {
        if (it?.id) {
            aGamerList[idx] = {
                ...it,
                isWatchCards: false,
                isShowCard: false,
                inGame: false,
                isQuit: false,
                isLose: false,
                cards: [],
            };
        }
    });
    mine.raiseNum = Number(roomTable.minBet);
}

// 初始化玩家操作信息
const initMsg = () => {
    msgList.forEach((_, i) => {
        msgList[i] = undefined;
    });
}

const initPk = () => {
    clearTimer('pkInit');
    clearTimer('pKResult');
    clearTimer('pkLineHide');
    clearTimer('pkVsHide');
    oVisible.showBlackMask = false;
    oVisible.showResult = false;
    oVisible.showSelect = false;
    oVisible.showPkLine = false;
    oVisible.showPkVs = false;
    oGameResult.pk = [];
}

const initBool = () => {
    isAuto.value = false;
    isOver.value = false;
    isAllIn.value = false;
    ischangeFail.value = false;
    hasShownCard.value = false;
    isReady.value = false;
}

// 游戏开始计时
const startReadyCountdown = () => {
    clearTimer('ready');
    // 确保倒计时初始值不为负数
    if (seconds.ready <= 0) {
        seconds.ready = defaultSeconds.ready;
    }
    oVisible.showReady = true;
    timers.ready = setInterval(() => {
        seconds.ready -= 1;
        if (seconds.ready <= 1) isReady.value = true;
        console.log('游戏开始倒计时', seconds.ready);
        // 如果倒计时已经小于等于0，立即清除定时器
        if (seconds.ready <= 0) {
            console.log('游戏开始倒计时结束,开始游戏！');
            clearTimer('ready');
            startGameStartGuard();
        }
    }, 1000);
}

// 回合倒计时
const startBettingCountdown = () => {
    clearTimer('round');
    timers.round = setInterval(() => {
        if (seconds.round === 3) {
            playMusic('alarm');
        }
        seconds.round -= 1;
        console.log('开始回合倒计时', seconds.round);
        if (seconds.round <= 0) {
            clearTimer('round');
        }
    }, 1000);
}

const handleReadyToplay = (enableTimer = true) => {
    initPlayer();
    clearAllTimer('change');
    initMsg();
    initBool();
    initPk();
    enableTimer && startReadyCountdown();
}

// 开始比牌
const startPk = async (user: Player) => {
    console.log('开始比牌', user);
    clearTimer('round')
    setMsg({ uid: userStore.id }, 'Match');
    const res = await EMIT_ZHAJINHUA_COMPAIRE({
        currency: currency.value,
        frontID: new Date().getTime(),
        hallName: hallName.value,
        tableID: mine.tableId,
        round: roomTable.currentRound,
        comparePlayerId: user.id,
    });
}

const setCards = (res, idx?: number) => {
    const targetIdx = idx ?? mine.seatIndex;
    if (!aGamerList[targetIdx]) return;
    aGamerList[targetIdx].cards = res.cards || [];
    aGamerList[targetIdx].cardType = res.cardType;
}
// -------- ↓ 按钮交互操作 ------------------------------- 
// 看牌
/**
 * @param {boolean} isDelay - 是否延时设置卡牌
 * @param {boolean} isAutoSee - 是否自动看牌（非点击看牌）
 */
const viewCard = async (isDelay = false, isAutoSee = true) => {
    toggleRaiseOption(false);
    if (!aGamerList[mine.seatIndex]) return;
    aGamerList[mine.seatIndex].isWatchCards = true;
    const res = await EMIT_ZHAJINHUA_SEE({ currency: currency.value, frontID: new Date().getTime(), hallName: hallName.value, tableID: mine.tableId, isAuto: isAutoSee });
    if (isDelay) {
        timers.pkView = setTimeout(() => {
            setCards(res);
        }, 1500);
    } else {
        setCards(res);
    }
}

// 弃牌
const onFold = async () => {
    toggleRaiseOption(false);
    oVisible.showSelect = false;
    roomTable.status = '';
    if (!aGamerList[mine.seatIndex]) return;
    aGamerList[mine.seatIndex].isWatchCards = true;
    const res = await EMIT_ZHAJINHUA_FOLD({ currency: currency.value, frontID: new Date().getTime(), hallName: hallName.value, tableID: mine.tableId });
    setCards(res);
    console.log('弃牌', res);
    clearAllTimer();
    setMsg({ uid: userStore.id }, 'Fold');
    joinStateStore.gameRunning = false;
}

// 跟注
const onCall = () => {
    oVisible.showSelect = false;
    console.log(isLastBet.value ? '最后一搏' : '跟注', process.env.NODE_ENV === 'development' ? JSON.stringify(aGamerList) : aGamerList, mine.raiseNum);
    roomTable.currentTurnPlayerID = 0;
    toggleRaiseOption(false);
    EMIT_ZHAJINHUA_CALL({
        currency: currency.value, frontID: new Date().getTime(),
        hallName: hallName.value, tableID: mine.tableId,
        round: roomTable.currentRound,
        isLast: isLastBet.value ? 1 : 0, // 最后一搏的时候是1
    });
}

// 跟到底
const onAutoCall = () => {
    if (roomTable.currentTurnPlayerID !== userStore.id) return;
    clearTimer('autoCall');
    if (isAuto.value && roomTable.currentRound <= 10) {
        timers.autoCall = setTimeout(() => {
            onCall();
        }, defaultSeconds.autoCall * 1000);
    }
};

// 全押
const onAllIn = () => {
    oVisible.showSelect = false;
    toggleRaiseOption(false);
    const maxChips = (10 - roomTable.currentRound) * Number(roomTable.maxBet) * (isWatch.value ? 1 : 0.5);
    const mychips = Number(playerSelf.value?.chips ?? 0);
    EMIT_ZHAJINHUA_ALLIN({
        currency: currency.value, frontID: new Date().getTime(),
        hallName: hallName.value, tableID: mine.tableId,
        round: roomTable.currentRound,
        amount: mychips > maxChips ? maxChips : mychips
    });
}

// 加注
const onRaise = async (val) => {
    console.log('加注', val);
    oVisible.showSelect = false;
    oVisible.showRaiseOption = false;
    await EMIT_ZHAJINHUA_RAISE({
        currency: currency.value, frontID: new Date().getTime(),
        hallName: hallName.value, tableID: mine.tableId,
        round: roomTable.currentRound,
        amount: val,
    });
}

// 选择玩家进行比牌
const onCompare = () => {
    toggleRaiseOption(false);
    if (gamerInGame.value === 1) return;
    oVisible.showBlackMask = true;
    if (gamerInGame.value === 2) {
        const user = playerList.value.find(it => it && !it.isSelf && it.inGame && !it.isLose && !it.isQuit);
        if (user) startPk(user);
    } else {
        oVisible.showSelect = true;
    }
}

// 比牌选择中对手弃牌后，重新选择比牌
const reCompare = () => {
    oVisible.showCompareDialog = false;
    onCompare();
}

// 换桌
const changeTable = async () => {
    clearAllTimer();
    initBool();
    startMatchTime();
    timers.change = setInterval(() => {
        seconds.change -= 1;
        console.log(`换桌倒计时：${seconds.change}`);
        if (seconds.change === 0) clearTimer('change');
    }, 1000);
    // 在换桌请求之前关闭监听，避免 leftTable 事件触发时监听器还在，导致玩家闪烁
    fnCloseAll();
    const res = await EMIT_ZHAJINHUA_CHANGETABLE({ currency: currency.value, hallName: hallName.value, frontID: new Date().getTime() });
    if (res.code) {
        showNegativeNotify({
            position: 'top',
            message: res.error,
            type: 'warning',
        });
        if (![4008, 1000].includes(res.code)) {
            if (res.code !== -1) {
                goback();
            } else {
                backHome();
            }
            return;
        }
        // 错误码是 4008 或 1000（游戏正在进行中），还在当前页面
        // 需要重新获取牌桌信息，同步游戏状态
        ischangeFail.value = true;
        fnListen();
        await refreshTableInfo();
        return;
    }
    initPlayer();
    getReayTime(res.tableInfo);
    EMIT_ZHAJINHUA_EXIT({ currency: currency.value, tableID: mine.tableId, });
    ischangeFail.value = false;
    showNotify({
        position: 'center',
        message: $tFn('goldenFlower.changeRes'),
        timeout: 1000,
        icon: 'check_circle',
    });
    mine.tableId = undefined;
    if (['TableReadyToplay', "Waiting"].includes(res.tableInfo.status)) {
        initMsg();
    }
    setInfo(res.tableInfo, ['TableReadyToplay', "Waiting"].includes(res.tableInfo.status));
    msgList[4] = undefined;
    await EMIT_ZHAJINHUA_JOIN({ currency: currency.value, tableID: mine.tableId });
    fnListen();
    // if (gamerInGame.value === 0 && gamerNum.value > 1) {
    //     handleReadyToplay();
    // }
}

// 亮牌
const onShowCard = () => {
    if (hasShownCard.value) return;
    if (!aGamerList[mine.seatIndex]) return;
    hasShownCard.value = true;
    EMIT_ZHAJINHUA_SHOWCARD({ currency: currency.value, hallName: hallName.value, tableID: mine.tableId });
    playerRef.value[4]?.playShowCards();
    aGamerList[mine.seatIndex].isShowCard = true;
}
// -------- ↑ 按钮交互操作 ------------------------------- 

const setMsg = (v, key) => {
    const idx = playerList.value.findIndex(it => it?.id === v.uid);
    msgList[idx] = { key, val: v.amount, tag: key ? msgTag[key] : '' };
}

const setAmount = (v, isCompare = false) => {
    const idx = aGamerList.findIndex(it => it?.id === v.uid);
    if (!aGamerList[idx] || idx === -1) return;
    const isWatchCards = aGamerList.find(it => it?.id === v.uid)?.isWatchCards;
    aGamerList[idx].totalBet = Number(aGamerList[idx]?.totalBet) + Number(v.amount);
    mine.raiseNum = Number(isWatchCards ? v.amount / 2 : v.amount);
    roomTable.poolAmount = String(Number(roomTable.poolAmount) + Number(v.amount));
    if (!isCompare) {
        aGamerList[idx].chips = v.chips
    }
}

// 结算时通知后端，避免被提出牌局
const heartbeat = () => {
    try {
        EMIT_ZHAJINHUA_PLAYCONFIRM({
            currency: currency.value,
            hallName: hallName.value,
            tableID: mine.tableId,
        })
    } catch (error) {
    }
}

// 游戏结算
const gameOver = (data: any[] = []) => {
    // 结算的时候直接隐藏比牌提示弹窗，避免延时里去重置出现问题
    oVisible.showCompareDialog = false;
    roomTable.status = '';
    clearAllTimer(['pkLineHide', 'pkVsHide', 'pKResult', 'pkInit', 'change']);
    isOver.value = true;
    joinStateStore.gameRunning = false;
    if (!aGamerList[mine.seatIndex]) {
        isAutoLeave.value = true;
        return goback();
    }
    // 结算时延时看牌，以避免pk完就显示牌
    if (!isWatch.value && playerSelf.value?.inGame) {
        viewCard(true);
    }
    data.forEach(item => { 
        if (item?.player?.cards?.length) { 
            handleShowCard(item.player, item.position);
        }
    })
    aGamerList[mine.seatIndex].inGame = false;

    // 结算时飞筹码动画（输家 → 庄家 → 赢家）
    // 延时 400ms 开始动画，确保阶段二能在 gameOver 后 800ms（settled 事件后 800ms）与全局推送同步执行
    if (data?.length) {
        timers.chips = setTimeout(() => {
            try {
                playChipsSettlementAnimationWrapper(data);
            } catch (err) {
                console.error('chips animation error', err);
            }
        }, 400);
    }

    // 结算信息
    heartbeat();
    timers.settled = setTimeout(() => {
        data.forEach((it) => {
            setAmount({ ...it.player, uid: it?.player?.id });
            if (it.player?.id && it.player?.inGame) {
                setMsg({ ...it.player, amount: it.player.diff, uid: it?.player?.id }, 'Val');
            }
        });
        roomTable.poolAmount = '0';
    }, 1800);
    timers.over = setTimeout(() => {
        initPlayer();
        Object.keys(oVisible).forEach(key => {
            oVisible[key] = false;
        });
        initBool();
        initMsg();
        initPk();
        clearAllTimer();
    }, defaultSeconds.over * 1000);
}


// 设置当前牌桌及玩家信息
const setInfo = (data: any = {}, isClearCard = false) => {
    const { seats = [] } = data || {};
    const currentSelfSeatIndex = seats.findIndex(it => it.player?.id === userStore.id);
    roomTable.status = data?.status
    Object.keys(roomTable).forEach((key) => {
        roomTable[key] = data[key];
    });
    seats.forEach((it, idx) => {
        let res;
        if (it.player?.id) {
            const { inGame, cards = [], isQuit, isLose } = it.player;
            // res = { ...it.player, inGame: (isQuit || isLose) ? false : inGame };
            res = { ...it.player }
            if (isClearCard) {
                res.cards = [];
                res.inGame = false;
            } else if (inGame && cards.length === 0) {
                // 如果牌局已结束（isOver），不应该设置空的cards触发发牌动画
                // 检查是否所有玩家都不在游戏中（使用原始数据，而不是修改后的值）
                const allPlayersNotInGame = seats.every(seat => {
                    const player = seat.player;
                    if (!player?.id) return true;
                    // 使用原始的 inGame 值，考虑 isQuit 和 isLose
                    const playerInGame = player.inGame && !player.isQuit && !player.isLose;
                    return !playerInGame;
                });
                // 只有在游戏未结束且不是所有玩家都不在游戏中时，才设置空的cards触发发牌动画
                if (!isOver.value && !allPlayersNotInGame) {
                    res.cards = [{}, {}, {}];
                } else {
                    // 牌局已结束或所有玩家都不在游戏中，不设置空的cards，避免触发发牌动画
                    res.cards = [];
                }
            } else {
                res.cards = cards;
            }
        }
        aGamerList[idx] = { ...res, gender: aGamerList[idx]?.gender ?? Math.floor(Math.random() * 2) };
    });
    if (isGaming.value) {
        joinStateStore.gameRunning = true;
    } else {
        joinStateStore.gameRunning = false;
    }
    if (!mine.tableId) {
        const seatIndex = seats.findIndex(it => it.player?.id === userStore.id);
        mine.tableId = data.id;
        mine.seatIndex = seatIndex;
    }
    if (currentSelfSeatIndex === -1) {
        console.warn('牌桌同步数据中未找到当前玩家，执行自动离桌兜底');
        handleExpress({ uid: userStore.id });
    }
}

// 玩家长时间不操作
const handleExpress = (res, showMsg = false, toHome = false) => {
    if (res.uid === userStore.id) {
        joinStateStore.gameRunning = false;
        isAutoLeave.value = true;
        showMsg && showNegativeNotify({
            i18n: 'goldenFlower.notEnoughChips',
            position: 'top', // 在顶部弹出，防止侵入用户操作  
            type: 'warning',
            timeout: 1 * 1_000, // 驻留时长 ms
            actions: [],
        });
        if (toHome) {
            backHome();
        } else {
            goback();
        }
    } else {
        const idx = aGamerList.findIndex(it => it?.id === res.uid);
        aGamerList[idx] = undefined;
        msgList[idx] = undefined;
    }
}

// 处理玩家比牌
const handleCompare = (res: { winner: Player, loser: Player }) => {
    const i = aGamerList.findIndex(it => it?.id === roomTable.currentTurnPlayerID);
    // 比牌玩家声音
    playMusic('compare', aGamerList[i]?.gender);
    oVisible.showSelect = false;
    oVisible.showBlackMask = true;
    // 比牌闪电音效
    playMusic('lightning');
    const { winner, loser } = res;
    setAmount(res);
    // 更新玩家信息，但保留原来的 cards
    [winner, loser].forEach((player, i) => {
        const idx = player.currentSeatIndex;
        if (!aGamerList[idx]) return;
        aGamerList[idx] = { ...player, cards: aGamerList[idx].cards };
        // if (i === 1) aGamerList[idx].inGame = false;
    });

    // 计算 pk 顺序
    const ids = [winner.id, loser.id];
    if (loser.id === playerSelf.value?.id) {
        joinStateStore.gameRunning = false;
    }
    oGameResult.pk = playerList.value.reduce<number[]>((acc, p, idx) => {
        if (p && ids.includes(p.id)) acc.push(idx + 1);
        return acc;
    }, []);

    oGameResult.winner = String(playerList.value.findIndex(it => it?.id === winner.id) + 1);
    // 连线和VS球同时出现
    oVisible.showPkLine = true;
    oVisible.showPkVs = true;

    // 消失：连线先消失 → VS球消失 → 显示结果
    timers.pkLineHide = setTimeout(() => {
        oVisible.showPkLine = false;
    }, 500);

    timers.pkVsHide = setTimeout(() => {
        oVisible.showPkVs = false;
    }, 600);

    timers.pKResult = setTimeout(() => {
        oVisible.showResult = true;
        setMsg({ uid: loser.id }, 'Eliminate');
        if (aGamerList[loser.currentSeatIndex]) {
            aGamerList[loser.currentSeatIndex].inGame = false;
        }
        if (!isWatch.value && loser.id === playerSelf.value?.id) {
            viewCard();
        }
    }, 800);

    timers.pkInit = setTimeout(() => {
        initPk();
    }, 1300);
}

const handleNotice = async (res) => {
    if (res.uid !== playerSelf.value?.id) return;
    
    const mainText = $tFn('goldenFlower.inactiveWarning', { val: res.autoFoldTimes });
    
    // 如果弹窗正在显示，只更新内容不创建新弹窗
    if (isNoticeDialogShowing && dialog) {
        dialog.update({ mainText });
        return;
    }
    
    isNoticeDialogShowing = true;
    dialog = showNoticeDialog({
        title: $tFn('exitGame.tips'),
        mainText,
        mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
        giftIcon: false,
        persistent: false,
        themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
        dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,
        bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,
        oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,
    });
    // 弹窗关闭后重置标志
    dialog.finally(() => {
        isNoticeDialogShowing = false;
    });
}

const handleShowCard = (res, idx) => {
    setCards(res, idx);
    if (aGamerList[idx]) {
        aGamerList[idx].isShowCard = res.isShowCard;
    }
}

const initFinal = () => {
    if (!oVisible.showFinal) return;
    oVisible.showFinal = false;
    finalPlayer.list = [];
    finalPlayer.winIds = [];
    clearTimer('final');
}

// 终局比牌
const handlLast = (res) => { 
    finalPlayer.list = res?.finalCompPlayers.map((it) => ({ ...it, cards: [] })) || [];
    oVisible.showFinal = true;
    console.log('终局比牌', res);
    setTimeout(() => { 
        finalPlayer.list = res?.finalCompPlayers || []
        finalPlayer.winIds = res?.finalWinners?.map(it => it.id) || [];
    }, 1000);
    timers.final = setTimeout(() => {
        initFinal();
    }, 4000);
}
/**
 * 关闭监听，稍后将被赋值
 */
let fnClosePlayer = () => void 0;
let fnClosePlayerTable = () => void 0;
let fnCloseNotice = () => void 0;
let fnCloseSocketConnect = () => void 0;

// 不应打断比牌选择流程的事件（玩家进出房间等非游戏操作事件）
const nonInterruptiveEvents = new Set(['joinTable', 'leftTable', 'offLine', 'userLocked', 'forceleftTable', 'longTimeNoOperateNotice', 'notEnoughChips', 'gameBetaTesting', 'showCard', 'watchCard']);

let joiningHallPromise: Promise<unknown> | null = null;

// 玩家事件
const fnListenPlayer = (res) => {
    const key = res?.event;
    console.log('玩家事件:', key, process.env.NODE_ENV === 'development' ? res : JSON.stringify(res));
    const wasSelectingCompare = oVisible.showSelect;
    const isInCompareFlow = oVisible.showBlackMask || oVisible.showSelect;
    if (key !== 'playerCompare' && !(isInCompareFlow && nonInterruptiveEvents.has(key))) {
        initPk()
    }
    if (['playerCall', 'playerRaise'].includes(key)) {
        const i = playerList.value.findIndex(it => it?.id === res?.uid);
        if (i !== -1) playerRef.value[i]?.insertCoin();
    }
    switch (key) {
        // 入桌事件
        case 'joinTable':
            aGamerList[res.seatIndex] = res.playerInfo;
            break;
        case 'userLocked':
            handleExpress(res, false, true);
            break;
        case 'forceleftTable':
            handleExpress(res);
            break;
        // 离桌事件
        case 'leftTable':
            const idx = playerList.value.findIndex((v) => v?.id === res.uid);
            msgList[idx] = undefined;
            aGamerList[res.seatIndex] = undefined;
            break;
        // 等待玩家操作
        case 'waitingOperate':
            startBettingCountdown();
            setMsg(res, '');
            roomTable.currentTurnPlayerID = res.uid;
            roomTable.currentRound = res.round;
            onAutoCall();
            break;
        // 3次 提醒
        case 'longTimeNoOperateNotice':
            handleNotice(res);
            break;
        case 'offLine':
            if (res.uid === userStore.id) {
                showNegativeNotify({
                    position: 'top',
                    i18n: 'goldenFlower.ended',
                    type: 'warning',
                });
            }
            handleExpress(res);
            msgList[res.seatIndex] = undefined;
            aGamerList[res.seatIndex] = undefined;
            break;
        // 长时间无操作，踢出牌局
        case 'longTimeNoOperate':
        // 玩家余额不足下一局游戏，踢出牌局
        case 'notEnoughChips':
        // 游戏内测中
        case 'gameBetaTesting':
            handleExpress(res, key === 'notEnoughChips');
            break;
        // 看牌
        case 'watchCard':
            if (!aGamerList[res.seat.seatIndex]) break;
            playMusic('see', aGamerList[res.seat.seatIndex].gender);
            if (res.seat.isQuit) return;
            aGamerList[res.seat.seatIndex].isWatchCards = true;
            !isOver.value && setMsg({ uid: res.seat.playerId }, 'View');
            break;
        // 弃牌
        case 'playerFold':
            playMusic('fold', aGamerList[res.seatIndex]?.gender);
            setMsg({ uid: res.uid }, 'Fold');
            if (res.uid === playerSelf.value?.id && !isWatch.value) {
                viewCard();
            }
            if (aGamerList[res.seatIndex]) {
                aGamerList[res.seatIndex].inGame = false;
                aGamerList[res.seatIndex].isQuit = true;
                aGamerList[res.seatIndex].isLose = true;
            }
            if (res.uid === userStore.id) joinStateStore.gameRunning = false;
            // A正在选择比牌对手时，对手弃牌导致可选人数变化，弹窗提示重新比牌
            if (wasSelectingCompare && res.uid !== userStore.id) {
                oVisible.showCompareDialog = true;
            }
            break;
        // 跟牌
        case 'playerCall':
            setMsg(res, 'CallOnce');
            playMusic('call', aGamerList[res.seatIndex]?.gender);
            setAmount(res);
            break;
        // 比牌
        case 'playerCompare':
            handleCompare(res);
            // 音效已在 handleCompare 中播放，无需重复调用
            break;
        // 加注
        case 'playerRaise':
            playMusic('raise', aGamerList[res.seatIndex]?.gender);
            setMsg(res, 'RaiseVal');
            setAmount(res);
            break;
        // 全押
        case 'playerAllIn':
            playAllInAnimation(res.uid === userStore.id);
            // playMusic('callLast', aGamerList[res.seatIndex]?.gender);
            clearTimer('autoCall');
            setMsg(res, 'AllIn');
            setAmount(res);
            isAllIn.value = true;
            isAuto.value = false;
            break;
        case 'showCard':
            handleShowCard(res.seat, res.seat.seatIndex);
            break;
        // 最后一搏
        case 'playerCallLast':
            oVisible.showCallLast = true;
            playMusic('callLast', aGamerList[res.seatIndex]?.gender);
            setMsg(res, 'CallLast');
            setAmount(res);
            break;
        default:
            break;
    }
}

// 牌桌事件
const fnListenTable = (res) => {
    const key = res.event;
    console.log('牌桌事件', key, process.env.NODE_ENV === 'development' ? res : JSON.stringify(res));
    if (key !== 'finalComp') initFinal();
    switch (key) {
        // 准备开始
        case 'readyToplay':
            roomTable.currentTurnPlayerID = 0;
            handleReadyToplay();
            setInfo(res.tableInfo, true);
            joinStateStore.gameRunning = false;
            initPlayer();
            break;
        // 游戏开始
        case 'gameStart':
            clearTimer('gameStartGuard');
            isReady.value = false;
            nextTick(() => {
                res.tableInfo.seats.forEach((it) => {
                    const node = getPlayerComponentById(it.player?.id);
                    if (node) {
                        node.insertCoin();
                    }
                });
                // 筹码音效
                playMusic('chips');
            });
            setInfo(res.tableInfo);
            clearTimer('ready');
            // 发牌音效
            Sleep(100).then(() => {
                playMusic('deal');
            })
            break;
        // 玩家人数不足、退出倒计时
        case 'cancleGameStart':
            clearAllTimer();
            break;
        // 产生赢家
        case 'gameWinner':
            break;
        // 终局比牌
        case 'finalComp':
            handlLast(res);
            break
        // 正在结算
        case 'settled':
            gameOver(res.seats);
            break;
        default:
            break;
    }
}

// 横幅消息
const fnListenNotice = (res) => {
    const key = res.event;
    console.log('跑马灯消息', res);
    switch (key) {
        case 'bigWin':
            noticeList.push(res)
            break;
        default:
            break;
    }
}

// 启用广播监听（注册前先关闭旧监听，防止重复注册）
const fnListen = () => {
    console.log('进入牌桌，开始监听炸金花ws事件');
    fnClosePlayer();
    fnClosePlayerTable();
    fnCloseNotice();
    fnClosePlayerTable = ON_TABLE(fnListenTable); // 监听牌桌事件
    fnClosePlayer = ON_PLAYER(fnListenPlayer); // 监听玩家事件
    fnCloseNotice = ON_NOTICE(fnListenNotice); // 监听横幅消息
}

const fnCloseAll = () => {
    console.log('关闭炸金花监听');
    fnClosePlayer();
    fnClosePlayerTable();
    fnCloseNotice();
}

// 加入房间前先查询用户当前所在房间
const checkInfo = async () => {
    const res = await EMIT_CHECK_PLAYER_TABLEINFO({ currency: currency.value, frontID: new Date().getTime(), });
    console.log('checkInfo', res);
    mine.tableId = res.currentTableId;
    mine.seatIndex = res.currentSeatIndex;
    return res;
}

/**
 * 重新获取牌桌信息并同步状态
 * 用于：刷新页面恢复、换桌失败恢复等场景
 */
const refreshTableInfo = async () => {
    if (!mine.tableId) return false;
    const res: any = await EMIT_ZHAJINHUA_TABLEINFO({
        currency: currency.value,
        hallName: hallName.value,
        tableID: mine.tableId,
    });
    console.log('重新获取牌桌信息', process.env.NODE_ENV === 'development' ? JSON.stringify(res) : res);
    if (res.code) {
        showNegativeNotify(res.error);
        return false;
    }
    mine.raiseNum = res.currentTurnFollowAmount;
    const { seats = [] } = res;
    const len = seats.filter(it => it.occupied)?.length;
    const isGameIdle = !res.currentTurnremainingTime && !res.currentTurnPlayerID;
    const shouldClearCard = len === 1 || ['TableReadyToplay'].includes(res.status) || isGameIdle;
    setInfo(res, shouldClearCard);
    onAutoCall();
    res.seats.forEach((it) => {
        if (it.player?.id) {
            const { isLose } = it.player;
            if (isLose) setMsg({ uid: it.player?.id }, 'Eliminate');
        }
    });
    // 恢复倒计时（回合倒计时和准备倒计时互斥）
    const hasRoundTime = res.currentTurnremainingTime > 0;
    if (hasRoundTime) {
        getRoundTime(res);
    } else {
        getReayTime(res);
    }
    return true;
}

// 刷新页面或者加入房间时候获取回合倒计时
const getRoundTime = (res) => {
    // 刷新页面时候的回合倒计时
    const remainTime = res.currentTurnremainingTime;
    if (remainTime > 0) {
        seconds.round = Math.floor(remainTime); // 先取整数秒
        const ms = (remainTime - seconds.round) * 1000;
        // 先用一次 timeout 补齐小数部分
        if (ms > 0) {
            timers.backend = setTimeout(() => {
                clearTimer('backend');
                startBettingCountdown(); // 再进入正常 1s interval
            }, ms);
        } else {
            startBettingCountdown();
        }
    }
}

const getReayTime = (res) => {
    const remainTime = res.gameStartCountdown;
    console.log('getReayTime', remainTime)
    // 如果倒计时时间小于等于0，直接清除倒计时，不显示负数
    if (remainTime <= 0) {
        clearTimer('ready');
        clearTimer('backend');
        oVisible.showReady = false;
        return;
    }
    if (remainTime > 0) {
        // 向上取整显示，避免卡在整数秒上（如 9.9 显示 10）
        seconds.ready = Math.ceil(remainTime);
        const ms = (remainTime - Math.floor(remainTime)) * 1000; // 小数部分（毫秒）
        oVisible.showReady = true;
        
        // 立即开始倒计时，第一次间隔是小数部分，之后是 1 秒间隔
        clearTimer('backend');
        
        if (ms > 0 && ms < 1000) {
            // 先等待小数部分，然后立即减 1 并开始 1 秒间隔
            timers.backend = setTimeout(() => {
                clearTimer('backend');
                seconds.ready -= 1;
                if (seconds.ready <= 1) isReady.value = true;
                // 如果还有剩余秒数，继续 1 秒间隔倒计时
                if (seconds.ready > 0) {
                    timers.ready = setInterval(() => {
                        seconds.ready -= 1;
                        if (seconds.ready <= 1) isReady.value = true;
                        console.log('游戏开始倒计时', seconds.ready);
                        // 如果倒计时已经小于等于0，立即清除定时器
                        if (seconds.ready <= 0) {
                            console.log('游戏开始倒计时结束,开始游戏！');
                            clearTimer('ready');
                            startGameStartGuard();
                        }
                    }, 1000);
                } else {
                    console.log('游戏开始倒计时结束,开始游戏！');
                    startGameStartGuard();
                }
            }, ms);
        } else {
            // 如果没有小数部分或已经超过 1 秒，直接开始正常倒计时
            startReadyCountdown();
        }
    }
}

const fnJoinTheHallCore = async () => {
    try {
        fnCloseAll();
        clearAllTimer();
        isAutoLeave.value = false;
        const res = await checkInfo();
        const aList01 = getHallsList();
        if (res.currentTableId && hallName.value !== res.currentHall) {
            const intOrder = aList01.find(it => it.name === res.currentHall)?.intOrder
            const path = `/casino/zhajinhuaGame/indoor/${intOrder}`;
            isAutoLeave.value = true;
            clearAllTimer();
            console.log('已经在游戏中！')
            return useRouter().push({
                path: getLocalPath(path),
                query: {
                    name: res.currentHall,
                },
                replace: true, // 不生成历史记录
            });
        }
        if (mine.tableId) {
            // 已在牌桌中，刷新页面恢复状态
            const success = await refreshTableInfo();
            if (!success) {
                fnGoToEntrance();
                return;
            }
        } else {
            const res: any = await EMIT_ZHAJINHUA_JOINTABLE({
                hallName: hallName.value, frontID: new Date().getTime(), currency: currency.value
            });
            console.log('加入房间获取房间信息', res);
            if (+res?.code === 3308) { // 余额不足 
                fnBackToPortal();
                return;
            } else if (+res?.code === 4002) {
                fnBackToPortal();
                return;
            } else if (!res || res?.['error'] || res.code) {
                showNegativeNotify(res?.['error']);
                if (res?.code == -1) {
                    backHome();
                } else {
                    router.replace({
                        path: getLocalPath('/casino/zhajinhuaGame/entrance'),
                    });
                }
                return;
            }
            if (res.tableInfo.status === 'TableReadyToplay') {
                handleReadyToplay(false);
            }
            setInfo(res.tableInfo, res.tableInfo.status === 'TableReadyToplay');
            res.tableInfo.seats.forEach((it) => {
                if (it.player?.id) {
                    const { isLose, isQuit } = it.player;
                    if (isLose && isQuit) {
                        setMsg({ uid: it.player?.id }, 'Eliminate');
                    } else if (isQuit && !isLose) {
                        setMsg({ uid: it.player?.id }, 'Fold');
                    }
                }
            });
            mine.raiseNum = res.tableInfo.minBet;
            if (gamerInGame.value === 0 && gamerNum.value > 1) {
                getReayTime(res.tableInfo)
            } else {
                if (res.tableInfo.status !== "Finished") {
                    getRoundTime(res.tableInfo);
                }
            }
        }
        EMIT_ZHAJINHUA_JOIN({ currency: currency.value, tableID: mine.tableId });
        fnListen();
    } finally {
        toCloseLoading();
    }
};

const fnJoinTheHall = async () => {
    if (joiningHallPromise) {
        console.log('fnJoinTheHall: 上次入场流程仍在进行，复用同一流程');
        return joiningHallPromise;
    }
    joiningHallPromise = fnJoinTheHallCore().finally(() => {
        joiningHallPromise = null;
    });
    return joiningHallPromise;
};

const initSocketReconnectListener = () => {
    fnCloseSocketConnect();
    const onConnect = () => {
        // connect 会在首次连接与重连后触发；串行锁可避免重复注册监听
        void fnJoinTheHall();
    };
    socket.on('connect', onConnect);
    fnCloseSocketConnect = () => {
        socket.off('connect', onConnect);
    };
};

// ↓ 提示无法进入此厅（用于余额不足时驱逐用户） 
const fnBackToPortal = async () => {
    showLowBalanceDialog.value = true;
}

// 处理余额不足弹窗确认
const handleLowBalanceConfirm = async () => {
    await Sleep(100);
    // ↓ 跳到大厅页 
    fnGoToEntrance();
}

const showHistoryList = () => {
    oVisible.historyList = true;
};

const leave = async () => {
    const params = {
        currency: currency.value,
        frontID: new Date().getTime(),
        hallName: hallName.value,
        tableID: mine.tableId,
        // seatIndex: mine.seatIndex,
    }
    // ↓ 销毁消息监听器 
    fnCloseAll();
    clearAllTimer();
    if (!mine.tableId) return;
    // 如果是语言切换，不执行退出牌桌的逻辑，只断开监听推送
    if (isLanguageSwitching.value) {
        console.log('语言切换：跳过退出牌桌逻辑，只断开监听推送');
        await EMIT_ZHAJINHUA_EXIT({ currency: currency.value, tableID: mine.tableId, });
        // 保留 tableId，以便在 onMounted 时重新获取牌桌信息
        return;
    }
    // 退出当前牌桌
    if (!ischangeFail.value && !isAutoLeave.value) await EMIT_ZHAJINHUA_LEAVE(params);
    // 断开监听推送
    await EMIT_ZHAJINHUA_EXIT({ currency: currency.value, tableID: mine.tableId, });
    mine.tableId = undefined;
}

const startMatchTime = () => {
    clearTimer('roomWaiting');
    timers.roomWaiting = setInterval(() => {
        seconds.roomWaiting -= 1;
        if (seconds.roomWaiting === 0) {
            clearTimer('roomWaiting');
        }
    }, 1000)
}

ON_STATECHANGE(data => {
    if(!oRoute.path.includes(ZHAJINHUA_INDOOR)) return;
    if (data.status === 'locked') {
        if(showTimeDailog.value) {
            backHome();
        } else if (timers.ready || oVisible.showReady) {
            joinStateStore.gameRunning = false;
            clearTimer('ready');
            isReady.value = false;
            backHome();
        }
    }
});

ON_SERVICERESTART(() => {
    console.log('------服务重启完成------');
    if(!oRoute.path.includes(ZHAJINHUA_INDOOR)) return;
    joinStateStore.gameRunning = false;
    isAutoLeave.value = true;
    clearAllTimer();
    goback();
});
// -------- ↓ watch ------------------------------- 

// ↓ ws 重连时关闭遮罩 
watch(
    () => oGlobalStore.wsConnection,
    async (bNew, bOld) => {
        console.log('wsConnection ♦️♦️♦️', bNew);
        if (!bNew) return;
        toCloseLoading();
    },
);

//  取消跟到底时候清除对应定时器
watch(() => isAuto.value, (nVal) => {
    if (!nVal) clearTimer('autoCall');
});

// ↓ 房间是否准备好开始进行游戏
watch(() => gamerNum.value, () => {
    console.log(`当前玩家数：${gamerNum.value}， 游戏中玩家数：${gamerInGame.value}`);
    if (gamerNum.value <= 1) {
        const excludeKeys: TimerKey[] = ['over', 'change'];
        if (oVisible.showBlackMask || oVisible.showSelect) {
            excludeKeys.push('pkInit', 'pKResult', 'pkLineHide', 'pkVsHide');
        }
        clearAllTimer(excludeKeys);
    }
});

watch(() => showTimeDailog.value, (val) => { 
    console.log('-----', val);
    if(!val) {
        clearTimer('roomWaiting');
    } else {
        // 进入匹配等待态时，兜底清理上一局牌面，避免残留手牌显示
        initPlayer();
        initMsg();
        initPk();
        hasShownCard.value = false;
        oVisible.showCallLast = false;
        startMatchTime();
    }
})
/*  -------- ↑ watch -------------------------------  */

/* 
----------------------------------------------------------
-------- ↓ 最下方，生命周期 ------------------------------- 
----------------------------------------------------------
*/

onMounted(async () => {
    console.log('房间：开始进入 ▶️ 房间号：', oRoute?.params?.id, oRoute.query.name);

    // 在用户首次交互时解锁音频（点击、触摸等）
    const handleUserInteraction = () => {
        unlockAudio();
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('touchstart', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
    };
    document.addEventListener('click', handleUserInteraction, { once: true });
    document.addEventListener('touchstart', handleUserInteraction, { once: true });
    document.addEventListener('keydown', handleUserInteraction, { once: true });
    initSocketReconnectListener();

    await waitUnmount();
    // 如果 ws 已连接，主动触发一次加入；否则由 wsConnection watcher 触发
    if (oGlobalStore.wsConnection) {
        await fnJoinTheHall();
    }
});

onBeforeUnmount(async () => {
    console.log('房间：开始退出 ⏹️ 房间号：', oRoute?.params?.id, oRoute.query.name,);
    // ↓ 退房声明（置于顶部使早执行）
    setUnmountPending()
    fnCloseSocketConnect();
    // ↓ 清除炸金花相关音效，避免未播完的声音在刷新/切换页面时残留
    clearAllZhajinhuaSounds();
    try {
        await leave();
    } finally {
        finishUnmount();
    }
    oMusic?.toDestory();
    if (allInAnimationTimer) {
        clearTimeout(allInAnimationTimer);
        allInAnimationTimer = null;
    }
    clearAllTimer();
    console.log('房间：退出完毕');
});

let notifyFn
onBeforeRouteLeave(async (to, from, next) => {
    if (!import.meta.client) return;
    // 检测是否是语言切换：如果路由路径只是语言前缀不同，其他部分相同，则认为是语言切换
    const fromPathWithoutLang = from.path.replace(/^\/(en|cn)/, '');
    const toPathWithoutLang = to.path.replace(/^\/(en|cn)/, '');
    const isLangSwitch = fromPathWithoutLang === toPathWithoutLang &&
        JSON.stringify(from.query) === JSON.stringify(to.query) &&
        from.params.id === to.params.id;

    if (isLangSwitch) {
        // 语言切换，标记为语言切换，不阻止路由跳转
        isLanguageSwitching.value = true;
        console.log('[路由守卫] 检测到语言切换：', from.path, '->', to.path);
        return next();
    }

    // 浏览器回退到首页时的纠偏统一由全局中间件处理，避免此处 next(false) 吞掉一次回退
    if (joinStateStore.gameRunning || isReady.value) {
        if (notifyFn) {
            notifyFn();
        };
        notifyFn = showNegativeNotify({
            i18n: isReady.value ? 'goldenFlower.gameReady' : 'goldenFlower.gameRun',
            position: 'top', // 在顶部弹出，防止侵入用户操作  
            type: 'warning',
            timeout: 1 * 1_000, // 驻留时长 ms
            actions: [],
        });
        return next(false);
    } else {
        // 游戏未进行，直接允许离开
        console.log('[路由守卫] 游戏未进行，直接允许离开');
        return next();
    }
})

</script>

<style scoped src="./style/indoor.scss"></style>
<style scoped src="./style/game-bottom-part.scss"></style>
<style scoped>
.game-stage {
    position: relative;
}

.chips-layer {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: visible;
}

.flying-chip {
    position: absolute;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(var(--start-x), var(--start-y)) scale(0.8);
    animation: chip-fly 0.7s ease-out forwards;
}
.room-name {
    font-family: HYZhengYuan;
    font-weight: 600;
    font-size: 39.6px;
    line-height: 39.6px;
    text-align: center;
    vertical-align: middle;
    position: absolute;
    bottom: 180px;
    color: rgba(10, 81, 51, 1);
}

.logo {
    position: absolute;
    width: 65px;
    height: auto;
    bottom: 240px;
}
.dealer-wager-box {
    position: relative;
}
.dealer-box-img {
    position: absolute;
    width: 49px;
    height: 34px;
    top: -8px;
    right: -55px;
}

@keyframes chip-fly {
    0% {
        transform: translate(var(--start-x), var(--start-y)) scale(0.7);
        opacity: 0;
    }

    40% {
        opacity: 1;
    }

    100% {
        transform: translate(var(--end-x), var(--end-y)) scale(1);
        opacity: 0;
    }
}
.z3 {
    z-index: 3 !important;
}
</style>
